// Login
export const DESTINATIONS_TOUR = '0c5117de-6b0d-4fca-8d38-71196763185b';
export const DMO_ONLY_TOUR = '85587cdf-f062-4e90-a75f-1cb6c44deb24';
export const CUSTOM_COMPSETS_TOUR = 'd13f4d34-e0f2-4b0b-b55e-08e49ae558c8';
export const CALENDAR_TOUR = '864ae0bd-cf4d-4e36-a648-1c3e145a7345';
export const OPPORTUNITIES_HINTS = '926a21ed-467d-4b98-9031-29a0222459e6';
export const PERSONALIZATION = '78907939-d871-49a4-9633-6c5811129070';
export const SIDEBAR_TOUR = '462fbd48-2487-4288-811c-090feb40e4f5';
